import useAppSelector from "stores/useAppSelector";
const useDLPreviewSelector = (fn) => useAppSelector(fn);
export default useDLPreviewSelector;
